/* eslint-disable @typescript-eslint/no-explicit-any */
import service from '@/services/service'

const resource = {
    main: 'services',
    module: 'broadcasts'
}

export class BroadcastServices {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    public static createBroadcast (params: any) {
        const form = new FormData()
        form.append('uploadfile', params.uploadfile)
        return service.post(`${resource.main}/${resource.module}`, form, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
    }
}
